// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TReferralGetLinkModel, IMappers, TReferralGetLinkResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetReferralLinkResponse } from '../../../entities/v1_get_referral_link/V1GetReferralLinkResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createReferralGetLinkModel(): TReferralGetLinkModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'cpd',
    pathApi: '/v1/referral/get-link/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IReferralGetLinkOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchReferralGetLink<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IReferralGetLinkOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TReferralGetLinkResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createReferralGetLinkModel(),
    config,
  )) as FetchResponse<TReferralGetLinkResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetReferralLinkResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TReferralGetLinkResponse>;
}
